import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import SettingsCurrencyConversionProfile from 'lumen/components/settings/currency-conversion/profile';
import type HotelSettingsCurrencyConversionProfileController from 'lumen/controllers/hotel/settings/currency-conversion/profile';
import type HotelSettingsCurrencyConversionProfileRoute from 'lumen/routes/hotel/settings/currency-conversion/profile';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsCurrencyConversionProfileSignature {
  Args: {
    controller: HotelSettingsCurrencyConversionProfileController;
    model: ModelFrom<HotelSettingsCurrencyConversionProfileRoute>;
  };
}

const HotelSettingsCurrencyConversionProfile: TOC<HotelSettingsCurrencyConversionProfileSignature> =
  <template>
    {{#if @model.exchangeRatesProfile.isRunning}}
      <PrismLoadingBar />

    {{else}}
      <SettingsCurrencyConversionProfile
        @baseCurrencies={{or @model.baseCurrencies.last.value (array)}}
        @exchangeRatesProfile={{@controller.exchangeRatesProfile}}
        @isLoading={{@model.exchangeRatesProfile.isRunning}}
        @isReadOnly={{true}}
        @onNavigateToPortfolio={{@controller.navigateToPortfolio}}
        @portfolioAccess={{@controller.portfolioAccess}}
      />
    {{/if}}
  </template>;

export default HotelSettingsCurrencyConversionProfile;
